export default __webpack_public_path__ + "static/media/img-10.769b7b4a.jpg";